import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TabUnselectedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tab_unselected"}/>
}
